document.addEventListener('DOMContentLoaded', () => {
  const sectionContainer = document.querySelector(
    '.fitness-tracker-min-statistics'
  );
  const popup = sectionContainer.querySelector(
    '.fitness-tracker-min-statistics_sleep-popup'
  );
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  let scrollPosition = 0;
  function disableScroll() {
    if (isIOS) {
      scrollPosition = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollPosition}px`;
      document.body.style.left = 0;
      document.body.style.right = 0;
      document.body.style.overflow = 'hidden';
    }
  }
  function enableScroll() {
    if (isIOS) {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.overflow = '';
      window.scrollTo(0, scrollPosition);
    }
  }
  sectionContainer
    .querySelector('.fitness-tracker-min-statistics_popup-button')
    .addEventListener('click', () => {
      popup.classList.add('active');
      disableScroll();
    });
  popup.addEventListener('click', e => {
    if (e.currentTarget === e.target) {
      popup.classList.remove('active');
      enableScroll();
    }
  });
  sectionContainer
    .querySelector('.fitness-tracker-min-statistics_sleep-popup_close_button')
    .addEventListener('click', () => {
      popup.classList.remove('active');
      enableScroll();
    });

  const stepsAnimationChilds = sectionContainer.querySelectorAll(
    '#fitness_steps_anim path:not(:last-child)'
  );
  const recursiveStepsAnimation = index => {
    if (index === -1) {
      stepsAnimationChilds.forEach(e => {
        e?.classList?.remove('step-active');
      });
      setTimeout(() => {
        recursiveStepsAnimation(stepsAnimationChilds.length - 1);
      }, 1100);
    }
    stepsAnimationChilds[index]?.classList?.add('step-active');
    stepsAnimationChilds[index]?.addEventListener(
      'transitionend',
      () => {
        recursiveStepsAnimation(index - 1);
      },
      { once: true }
    );
  };
  recursiveStepsAnimation(stepsAnimationChilds.length - 1);

  const swiper = new Swiper('.fitness-tracker-min-statistics .swiper', {
    direction: 'vertical',
    loop: true,
    allowTouchMove: false,
    slidesPerView: 'auto',
    centeredSlides: true,
    spaceBetween: 12,
    autoplay: {
      delay: 1000
    },
    breakpoints: {
      1024: {
        init: false
      }
    }
  });
});
